import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default (function (svgString) {
  var match = svgString && svgString.match(/<svg (.*?)>(.*?)<\/svg>/);
  var attributes = {};

  if (match) {
    var currentAttribute = [];
    var skipAttributes = ["xmlns", "xmlns:xlink"];

    var _match = _slicedToArray(match, 3),
        attributesString = _match[1],
        innerHTML = _match[2];

    var getAttributes = /(\S*?)="(.*?)"/g;

    while ((currentAttribute = getAttributes.exec(attributesString)) !== null) {
      if (skipAttributes.includes(currentAttribute[1])) {
        continue;
      }

      attributes[currentAttribute[1]] = currentAttribute[2];
    }

    return {
      attributes: attributes,
      innerHTML: innerHTML
    };
  }

  return {
    attributes: attributes,
    innerHTML: ""
  };
});